import { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { find, last, map, reduce } from 'lodash'
import { Select } from 'components/forms'
import classNames from 'classnames'
import { getHistory } from 'lib/history'
import { getSlugSetForSlug } from 'store/reducers'

import css from './category-select.scss'

class CategorySelect extends Component {
  static propTypes = {
    activeSlugSet: PropTypes.array,
    categoryTree: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string.isRequired,
        path: PropTypes.string.isRequired,
        urlSlug: PropTypes.string.isRequired,
        image: PropTypes.string,
      })
    ).isRequired,
    globalSearchBarEnabled: PropTypes.bool,
  }

  render() {
    return (
      <div
        className={classNames(
          css.categorySelect,
          'visible-xs container',
          this.props.globalSearchBarEnabled ? 'ptl' : 'mtm'
        )}
      >
        <Select
          size="small"
          variant="muted"
          style={{ fontSize: '16px' }} // min $mobile-font-size for form elements
          onChange={this.handleChangeCategory.bind(this)}
        >
          <option value="" disabled selected hidden>
            Select a category
          </option>
          {map(this.optionsForSelect(), (cat) => {
            if (cat.hidden) return null
            return (
              <option value={cat.urlSlug} key={cat.urlSlug}>
                {cat.title}
              </option>
            )
          })}
        </Select>
      </div>
    )
  }

  optionsForSelect() {
    let { categoryTree, activeSlugSet } = this.props

    let storeHome = {
      title: 'Shop',
      path: '/store',
      urlSlug: 'store',
    }

    let options = [storeHome]
    let includesNoSalePreviewSlugs = activeSlugSet.every(
      (slug) => !BLConstants.SALE_PREVIEW_CATEGORY_SLUGS.includes(slug)
    )

    // TODO: could possibly be simplified and refactored to use activeCategory
    //       and categories instead of categoryTree
    if (activeSlugSet.length && includesNoSalePreviewSlugs) {
      reduce(
        activeSlugSet,
        (categoryLevel, slug, i) => {
          let nextLevel = find(categoryLevel, (c) => c.urlSlug === slug)
          if (i === activeSlugSet.length - 1) {
            // TODO: "All in ___" categories
            if (nextLevel.children && nextLevel.children.length) {
              options.push(nextLevel)
              options = options.concat(nextLevel.children)
            } else {
              options = options.concat(categoryLevel)
            }
            return
          } else {
            options.push(nextLevel)
            return nextLevel.children
          }
        },
        categoryTree
      )
    } else {
      options = options.concat(categoryTree)
    }

    return options
  }

  handleChangeCategory(e) {
    let history = getHistory({ useRouter: true })
    history.push(
      find(this.optionsForSelect(), (c) => c.urlSlug === e.target.value).path
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    categoryTree: state.categoryTree,
    activeSlugSet: getSlugSetForSlug(state, ownProps.activeSlug),
  }
}

export default connect(mapStateToProps)(CategorySelect)
